export const FETCH_JOBS_INFO = 'FETCH_JOBS_INFO';
export const FETCH_JOBS_INFO_SUCCESS = 'FETCH_JOBS_INFO_SUCCESS';
export const FETCH_JOBS_INFO_ERROR = 'FETCH_JOBS_INFO_ERROR';
